import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import { HelperService } from "../../helper.service";
import { catchError, Observable, retry } from "rxjs";
import {BaseService} from "../../services/base.service";
import {OrderListItemModel} from "../models-otc/order-list-item-model";
import {PageModel} from "../models-otc/page-model";
import {ApprovalsModel} from "../models-otc/approvals-model";


@Injectable({
    providedIn: 'root'
})
export class SearchOrdersService extends BaseService{

    userId = this.helper.getUserId();
    constructor(
        private httpClient: HttpClient,
        public snackBar: MatSnackBar,
        public helper: HelperService
    ) {
        super();
    }

    getOrderList(page: number, size: number,searchQuery:string, clientIds: number[], fromDate:string, toDate: string, statusIds:number[], plantIds: number[], materialIds: number[]): Observable<PageModel<OrderListItemModel[]>> {

        let params = new HttpParams()
            .set('page', page.toString())
            .append('size', size.toString())

        if (searchQuery) {
            params = params.append('searchQuery', searchQuery);
        }

        if (clientIds) {

            clientIds.forEach((element)=>{
                params = params.append('clientIds', element.toString());
            })

        }
        if (fromDate) {
            params = params.append('fromDate', fromDate);
        }

        if (toDate) {
            params = params.append('toDate', toDate);
        }
        if (statusIds) {
            statusIds.forEach((element)=> {
                params = params.append('statusIds', element.toString());
            })
        }

        if (plantIds) {
            plantIds.forEach((element)=> {
                params = params.append('plantIds', element.toString());
            })
        }

        if (materialIds) {
            materialIds.forEach((element)=> {
                params = params.append('materialIds', element.toString());
            })
        }

        return this.httpClient.get<PageModel<OrderListItemModel[]>>(this.OTC_BASE_URL + `orders/managerorders`, {params})
            .pipe(
                retry(0),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving Order Status List','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    getOrderHistoryList(page: number, size: number,searchQuery:string, clientIds: number[], fromDate:string, toDate: string, statusIds:number[], plantIds: number[], materialIds: number[]): Observable<PageModel<OrderListItemModel[]>> {

        let params = new HttpParams()
            .set('page', page.toString())
            .append('size', size.toString())

        if (searchQuery) {
            params = params.append('searchQuery', searchQuery);
        }

        if (clientIds) {

            clientIds.forEach((element)=>{
                params = params.append('clientIds', element.toString());
            })

        }
        if (fromDate) {
            params = params.append('fromDate', fromDate);
        }

        if (toDate) {
            params = params.append('toDate', toDate);
        }
        if (statusIds) {
            statusIds.forEach((element)=> {
                params = params.append('statusIds', element.toString());
            })
        }

        if (plantIds) {
            plantIds.forEach((element)=> {
                params = params.append('plantIds', element.toString());
            })
        }

        if (materialIds) {
            materialIds.forEach((element)=> {
                params = params.append('materialIds', element.toString());
            })
        }

        return this.httpClient.get<PageModel<OrderListItemModel[]>>(this.OTC_BASE_URL + `orders/orderhistory`, {params})
            .pipe(
                retry(0),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving Order Status List','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    getApprovalList(page: number, size: number,searchQuery:string, clientIds: number[], fromDate:string, toDate: string, statusIds:number[]): Observable<PageModel<ApprovalsModel[]>> {

        let params = new HttpParams()
            .set('page', page.toString())
            .append('size', size.toString())

        if (searchQuery) {
            params = params.append('searchQuery', searchQuery);
        }


        if (clientIds) {

            clientIds.forEach((element)=>{
                params = params.append('clientIds', element.toString());
            })

        }
        if (fromDate) {
            params = params.append('fromDate', fromDate);
        }

        if (toDate) {
            params = params.append('toDate', toDate);
        }

        if (statusIds) {
            statusIds.forEach((element)=> {
                params = params.append('statusIds', element.toString());
            })
        }
        return this.httpClient.get<PageModel<ApprovalsModel[]>>(this.OTC_BASE_URL + `orders/approvals`, {params})
            .pipe(
                retry(1),
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving Approvals List','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }
}
